import { styled } from "../theme";
/**
 * A styled anchor tag for external links.
 *
 * @param {object} props The props for the component.
 * @param {boolean} [props.disabled=false] Whether the link is disabled.
 */
export const ExternalLink = styled.a `
  color: ${({ theme }) => theme.color.primary};

  ${({ disabled, theme }) => disabled &&
    `
      color: ${theme.color.gray100};
      cursor: not-allowed;
      pointer-events: none;
    `}
`;
ExternalLink.defaultProps = {
    target: "_blank",
    rel: "noopener noreferrer",
    disabled: false,
};
